import {Result} from 'antd';
import styled from 'styled-components';

const StyledPaymentSuccessMessage = styled(Result)`
  padding: 0;

  .ant-result-icon {
    margin-bottom: 16px;
  }

  svg {
    height: 80px;
    width: 82px;
  }

  .ant-result-title {
    color: ${props => props.theme.colors.neutral_10};
    font-weight: 600;
    font-size: 20px;
    margin: 0 0 16px 0;
  }

  .ant-result-subtitle {
    color: ${props => props.theme.colors.neutral_7};
    font-size: 16px;
    line-height: 28px;
    margin: 0;
  }

  .ant-result-extra {
    margin-top: 16px;
  }
`;


export {
  StyledPaymentSuccessMessage,
}
